import * as Yup from 'yup';

export type SearchByOpts = 'address' | 'permit' | 'project_id' | 'client' | '';

export const ALL_OPT = {
  id: '',
  name: 'All',
};

export const SEARCH_TYPES_AGENCY = [
  { name: 'Select', id: '' },
  { name: 'Address', id: 'address' },
  { name: 'Permit Number', id: 'permit' },
  { name: 'Inspector', id: 'inspector' },
  { name: 'PIC/MCP', id: 'pic_inspector' },
  { name: 'Inspector or PIC/MCP', id: 'inspector_pic_mcp' },
  { name: 'Project Number', id: 'project_id' },
  { name: 'Client', id: 'client' },
  { name: 'Event Number', id: 'id' },
];

export const GEO_STATUS_OPTIONS = [
  { name: 'Enabled', id: 'enabled' },
  { name: 'Missing', id: 'failed' },
];

export const UNSAFE_CONDITIONS_OPTIONS = [
  { name: 'Yes', id: true },
  { name: 'No', id: false },
];

export const REPORT_SUBMISSION_OPTIONS = [
  { name: 'In time', id: true },
  { name: 'Late', id: false },
];

export const STATUS_FILTERS = [
  { name: 'Ongoing', idAsParent: 'ongoing', id: 'optgroup' },
  { name: 'Upcoming', id: 'upcoming', parentId: 'ongoing' },
  { name: 'In Progress', id: 'in_progress', parentId: 'ongoing' },
  { name: 'In QA', id: 'in_qa', parentId: 'ongoing' },
  { name: 'Ready For Issuance', id: 'ready_for_issuance', parentId: 'ongoing' },

  { name: 'Cancelled', idAsParent: 'cancelled', id: 'optgroup' },
  { name: 'Cancelled by Admin', id: 'cancelled_by_admin', parentId: 'cancelled' },
  { name: 'Cancelled by Client', id: 'cancelled_by_client', parentId: 'cancelled' },
  { name: 'Cancelled by Agency', id: 'cancelled_by_agency', parentId: 'cancelled' },
  { name: 'Cancelled by Inspector', id: 'cancelled_by_inspector', parentId: 'cancelled' },

  { name: 'Completed', id: 'optgroup', idAsParent: 'completed' },
  { name: 'Finalized Report (single insp. payment)', id: 'finalized_report', parentId: 'completed' },
  { name: 'Ready to invoice (multiple insp.payment)', id: 'ready_to_invoice', parentId: 'completed' },
  { name: 'Invoiced (multiple insp.payment)', id: 'invoiced', parentId: 'completed' },
  { name: 'Payment in Progress', id: 'payment_in_progress', parentId: 'completed' },
  { name: 'Paid', id: 'paid', parentId: 'completed' },
  { name: 'Payment Failed', id: 'payment_failed', parentId: 'completed' },
];

export const PROJECT_TYPES = [
  { name: 'Regular', id: 'regular' },
  { name: 'Special', id: 'special' },
  { name: 'DOEE', id: 'doee' },
];

export interface FormValues {
  searchBy: SearchByOpts;
  query: string;
  agencyCompanyId: string;

  geolocationStatus: string;
  unsafeConditions: boolean | '';
  submissionTimeMet: boolean | '';
  jobType: string;

  dateFrom: string | null;
  dateTo: string | null;

  finalizedAtFrom: string | null;
  finalizedAtTo: string | null;

  states: string[];
}

export const defaultValues: FormValues = {
  searchBy: '',
  query: '',
  agencyCompanyId: '',

  geolocationStatus: '',
  unsafeConditions: '',
  submissionTimeMet: '',
  jobType: '',

  dateTo: null,
  dateFrom: null,

  finalizedAtFrom: null,
  finalizedAtTo: null,

  states: [],
};

const detailsFields = {};

export const getValidationSchema = () => {
  return Yup.object({
    ...detailsFields,
  });
};
